;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.shared.localization.dictionaries
  (:require
   [renolit-roofing-service.shared.localization.dictionaries.es :as dictionaries.es]))

(def dictionaries
  {:es dictionaries.es/registry
  ;;  :en dictionaries.en/registry
   })

(def ^:const default-language :es)

(def ^:const languages (set (keys dictionaries)))
